<template>
  <div id="footer">
    <div class="w-container">
      <div class="w-layout-grid grid-3">
        <div id="w-node-138e9d4e3016-9d4e3013" class="div-block-14">
          <p class="text-footer-2">{{ $t("footer.follow") }}</p>
          <a
            href="https://facebook.com/MadrigalOficial"
            target="_blank"
            class="social-link"
          >
            <img :src="fb_logo" height="43" alt="" class="image-6" />
          </a>
          <a
            href="https://www.youtube.com/user/MadrigalOficial"
            target="_blank"
            class="social-link"
          >
            <img :src="yt_logo" height="43" alt="" class="image-6" />
          </a>
        </div>
        <div id="w-node-138e9d4e301a-9d4e3013" class="div-block-13">
          <div class="madrigal-logo-footer">
            <img :src="madrigal_logo" alt="" />
            <p class="text-footer">{{ $t("footer.copyright") }}</p>
          </div>
          <div class="emergency-logo">
            <a href="https://www.sts.ro/ro/servici/112-serviciul-de-urgenta">
              <img :src="logo_112" height="60" width="60" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data: function() {
    return {
      fb_logo: require("../assets/images/facebook-letter-logo.png"),
      yt_logo: require("../assets/images/youtube.png"),
      madrigal_logo: require("../assets/images/logo-copy.png"),
      logo_112: require("../assets/images/112.png")
    };
  }
};
</script>

<style scoped>
.div-block-13 {
  display: flex;
  flex-direction: row;
}

.madrigal-logo-footer {
  flex-grow: 1;
}

.emergency-logo {
  justify-self: end;
  align-self: flex-end;
}

#footer {
  padding-top: 38px;
  padding-bottom: 38px;
  background-color: #516b80;
  color: white;
}

.grid-3 {
  -ms-grid-columns: 2.5fr 1fr;
  grid-template-columns: 2.5fr 1fr;
  -ms-grid-rows: auto;
  grid-template-rows: auto;
}

#w-node-138e9d4e3016-9d4e3013 {
  -ms-grid-column: 2;
  grid-column-start: 2;
  -ms-grid-column-span: 1;
  grid-column-end: 3;
  -ms-grid-row: 1;
  grid-row-start: 1;
  -ms-grid-row-span: 1;
  grid-row-end: 2;
}

.text-footer {
  margin-top: 18px;
  font-family: Roboto, sans-serif;
  font-size: 0.8em;
  font-weight: 300;
}

.social-link {
  margin-left: 20px;
}

.div-block-14 {
  display: flex;
  align-items: flex-end;
}

p {
  margin-bottom: 0;
}

.image-6 {
  height: 35px;
  opacity: 0.7;
  filter: alpha(opacity=50);
}

.image-6:hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
</style>
